import Accordion from './Accordion.vue'
import './accordion.scss'

export default Accordion
